export default __webpack_public_path__ + "static/documentation-global-header-01-961e83be9b56e4f5a96b085355d07fe8.jpg";